// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1816":"6be047972552748d","2235":"7881ce54c3a7a490","3465":"284ebe54142071aa","3782":"c1298c777db87adf","5085":"656812152ec07281","5724":"807c5e7bf1cbe3bd","8385":"3825cf391941bf2a"}[chunkId] + ".js";
};